import { AppText } from "../../ui-foundation";
import { DocumentList, DocumentPageScaffold, DocumentSection } from "@/components/DocumentScaffold";
import {
  KINDRED_SUPPORT_EMAIL,
  STEADY_HOUSE_LEGAL_NAME,
  STEADY_HOUSE_SUPPORT_URL,
} from "../../shared/support";

const ChildSafety = () => {
  return (
    <DocumentPageScaffold
      title="Child Safety Standards"
      updatedLabel="Last updated: April 2026"
      fallbackPath="/"
    >
      <DocumentSection title="Our position">
        <AppText>
          Kindred has zero tolerance for child sexual abuse and exploitation (CSAE), grooming, sexualised
          content involving minors, trafficking, or any behaviour that puts a child at risk.
        </AppText>
        <AppText>
          Accounts on Kindred are for adults. Parents may talk about family life and share age-appropriate
          family updates, but children must never be sexualised, exploited, contacted inappropriately, or
          placed at risk through content or behaviour on the platform.
        </AppText>
        <AppText>{STEADY_HOUSE_LEGAL_NAME} treats safeguarding and child-safety reports as a priority operational responsibility.</AppText>
      </DocumentSection>

      <DocumentSection title="What is prohibited">
        <DocumentList
          items={[
            "Any sexual content involving a child or anyone who may be under 18",
            "Grooming, coercion, exploitation, or attempts to build sexual contact with a minor",
            "Requests for child images, sexual conversations about children, or exploitative role-play",
            "Sharing, requesting, storing, or linking to CSAE material",
            "Using Kindred to facilitate offline abuse, trafficking, or contact with a child",
            "Posting identifying child information in ways that create a safeguarding risk",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="How members can report concerns">
        <AppText>If you see content or behaviour that may place a child at risk:</AppText>
        <DocumentList
          items={[
            "Use the in-app reporting tools where available",
            "Block the person immediately if there is an urgent safety concern",
            <>
              Use the{" "}
              <a
                href={STEADY_HOUSE_SUPPORT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="kindred-inline-link"
              >
                Steady House support page
              </a>{" "}
              or email{" "}
              <a href={`mailto:${KINDRED_SUPPORT_EMAIL}`} className="kindred-inline-link">
                {KINDRED_SUPPORT_EMAIL}
              </a>
            </>,
          ]}
        />
        <AppText>
          If a child is in immediate danger, contact emergency services or your local child-protection
          authority first.
        </AppText>
      </DocumentSection>

      <DocumentSection title="How Kindred responds">
        <DocumentList
          items={[
            "We review reports as a safeguarding priority",
            "We may remove content immediately while a report is assessed",
            "We may suspend or permanently ban accounts involved in serious risk or abuse",
            "We preserve relevant evidence where needed for safety, legal, or law-enforcement purposes",
            "Where appropriate, we report credible CSAE concerns to relevant authorities or child-protection bodies",
          ]}
        />
      </DocumentSection>

      <DocumentSection title="Contact">
        <AppText>
          For child-safety concerns, reporting issues, or questions about these standards, contact{" "}
          <a
            href={STEADY_HOUSE_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="kindred-inline-link"
          >
            the Steady House support page
          </a>{" "}
          or{" "}
          <a href={`mailto:${KINDRED_SUPPORT_EMAIL}`} className="kindred-inline-link">
            {KINDRED_SUPPORT_EMAIL}
          </a>
          .
        </AppText>
      </DocumentSection>
    </DocumentPageScaffold>
  );
};

export default ChildSafety;
